import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { useTour } from '@sorare/core/src/hooks/useTour';
import {
  SaleType,
  TOKENS_STACKED_LIMIT,
  createCardSorts,
} from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/nba';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { secondaryMarketFilters } from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';

const SecondaryMarket = () => {
  useTitleAndDescription(
    metadatas.transfers.title,
    metadatas.transfers.description
  );

  const cardSorts = createCardSorts({
    indexPrefix: 'Cards On Sale',
    withHighestAverageScore: true,
    withHighestPrice: false,
    withEndingSoon: false,
  });
  const defaultSort = 'Cards On Sale Highest Average Score';

  const filters = useDefaultFilters({
    secondary: true,
    onlySettlableCards: true,
    excludePrimaryOffers: true,
  });

  return (
    <MarketRoot>
      <NBACardSearch
        sorts={cardSorts}
        defaultSort={defaultSort}
        cardFilters={secondaryMarketFilters}
        defaultFilters={filters}
        analyticsTags={['TransferMarket', 'NBA']}
        removeEndedSingleSaleOffers
        distinct={TOKENS_STACKED_LIMIT}
        filtersTour={useTour(LIFECYCLE.transferMarket, 'filters')}
        cardsTour={useTour(LIFECYCLE.transferMarket, 'cards')}
        stackableTypes={[SaleType.SINGLE_SALE_OFFER]}
      />
    </MarketRoot>
  );
};
export default SecondaryMarket;
